import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// Remove Emergent badge if it appears
const removeBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.remove();
  }
  // Also remove any element with emergent in href
  document.querySelectorAll('a[href*="emergent"]').forEach(el => el.remove());
};

// Run on load and observe for changes
if (typeof window !== 'undefined') {
  window.addEventListener('load', removeBadge);
  setInterval(removeBadge, 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
